import { ready, fetchApiUrl } from './utilities';
import { colors } from './vars';
import { chartGradient } from './chart-helper';

const ACTIVE_CLASS = 'chart-switch__item--active';
const JS_CLASS = 'js-guru-performance-switch';
let chartEl;
let chart;
let performanceData;
let sp500ByDate;
let guruName;
let Chart;

ready(() => {
  chartEl = document.getElementById('portfolio-performance-chart');

  if (!chartEl) {
    return;
  }

  import('chart.js-legacy').then(init);
});

async function init(ChartModule) {
  Chart = ChartModule.default;
  const guruId = chartEl.dataset.guruId;
  guruName = chartEl.dataset.guruName || 'Portfolio';
  const response = await fetchApiUrl(
    '/api/v1/portfolio-metrics/performance?guru-id=' + guruId
  );
  performanceData = (await response.json()).reverse();
  const sp500El = document.getElementById('sp500-performance-data');
  const sp500Data = sp500El ? JSON.parse(sp500El.textContent) : [];
  sp500ByDate = sp500Data.reduce((lookup, row) => {
    lookup[row.date] = row.change_percent;
    return lookup;
  }, {});

  initChart(chartEl);

  document.querySelectorAll(`.${JS_CLASS}`).forEach((elem) => {
    elem.addEventListener('click', switchTimeframe);
  });
}

function initChart(chartEl) {
  const ctx = chartEl.getContext('2d');
  const [labels, portfolioPerformance, sp500Performance] = getData();

  const data = {
    labels,
    datasets: [
      {
        label: guruName,
        borderColor: colors.success.hex,
        borderWidth: 2,
        backgroundColor: chartGradient(ctx, colors.success.rgb),
        hoverBackgroundColor: colors.success.hex,
        data: portfolioPerformance,
      },
      {
        label: 'S&P 500',
        borderColor: colors.info.hex,
        borderWidth: 2,
        backgroundColor: 'transparent',
        hoverBackgroundColor: colors.info.hex,
        data: sp500Performance,
      },
    ],
  };

  Chart.defaults.global.defaultFontColor = 'rgba(255, 255, 255, 0.4)';
  chart = new Chart(ctx, {
    type: 'line',
    data: data,
    options: {
      animation: {
        duration: 0
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontSize: 14,
          usePointStyle: true,
        },
      },
      tooltips: {
        mode: 'index',
        position: 'nearest',
        intersect: false,
        callbacks: {
          title: tooltipTitle,
          label: tooltipLabel,
        },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              autoSkip: false,
              maxRotation: 0,
              callback: function (date) {
                if (date.getMonth() === 0 && date.getDate() === 1) {
                  return date.getFullYear();
                }
              },
            },
          },
        ]
      },
      elements: {
        point: {
          radius: 0
        }
      }
    },
  });
}

function getData(years = 10) {
  let labels = [];
  let portfolioPerformance = [];
  let sp500Performance = [];
  let portfolioCurrent = 1;
  let sp500Current = 1;
  let startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - years);

  for (let j in performanceData) {
    if (new Date(performanceData[j].date) >= startDate) {
      labels.push(new Date(performanceData[j].date));
      portfolioCurrent = portfolioCurrent * performanceData[j].change_percent;
      portfolioPerformance.push(portfolioCurrent);

      const sp500Change = sp500ByDate[performanceData[j].date];
      if (sp500Change) {
        sp500Current = sp500Current * sp500Change;
      }
      sp500Performance.push(sp500Current);
    }
  }

  return [labels, portfolioPerformance, sp500Performance];
}

function tooltipTitle(tooltipItem) {
  return tooltipItem[0].xLabel.toDateString();
}

function tooltipLabel(tooltipItem, data) {
  const label = data.datasets[tooltipItem.datasetIndex].label || '';
  const value = tooltipItem.yLabel;
  return `${label}: ${value.toFixed(2)}x (${(value * 100 - 100).toFixed(2)}%)`;
}

function switchTimeframe(event) {
  const targetElem = event.target;
  document.querySelector(`.${ACTIVE_CLASS}.${JS_CLASS}`).classList.remove(ACTIVE_CLASS);
  targetElem.classList.add(ACTIVE_CLASS);

  const [labels, portfolioPerformance, sp500Performance] = getData(
    parseInt(targetElem.dataset.guruPerformance)
  );
  chart.data.labels = labels;
  chart.data.datasets[0].data = portfolioPerformance;
  chart.data.datasets[1].data = sp500Performance;
  chart.update();
}
